export default __webpack_public_path__ + "static/media/Header123456copy.1df583d6.png";